import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from "gatsby";
import './section-more-sales.scss';
import CardSale from '../../atoms/card-sale/card-sale';

const SectionMoreSales = props => {
    const { sale } = props;
    const { tipoDeBien, ciudad, slug } = sale;

    const sql = graphql`
        query{
            contentfulPaginaBienesEnVenta {
                tituloMasBienesEnVenta
                textoDeApoyoMasBienesEnVenta
                bienesEnVenta{
                    createdAt
                    nombre
                    valorInmueble
                    slug
                    tipoDeBien
                    tagDeCategoria {
                        colorEtiquetas
                        nombreTab
                    }
                    imagenesPrevias {
                        file {
                            url
                        }
                    }
                    area
                    ciudad
                    direccionDelInmueble
                    metrosCuadradosConstruidos
                    cantidadDeHabitaciones
                    numeroDeBanos
                    fechaDeFinalizacinDeSubasta
                    cilindradaDelMotor
                    color
                    kilometraje
                    modelo
                    tipoTransmision
                    tipoVehiculo {
                        nombreTab
                    }
                }
            }
        }
    `

    const { contentfulPaginaBienesEnVenta } = useStaticQuery(sql);
    const { tituloMasBienesEnVenta, textoDeApoyoMasBienesEnVenta, bienesEnVenta } = contentfulPaginaBienesEnVenta;

    const [listSales, setListSales] = useState(null);

    useEffect(()=>{
        filterList();
    },[]);

    const filterList = () => {
        //console.log(slug);
        const departamento = (ciudad ) ? ciudad.split("-")[0] : 'd';
        const municipio = (ciudad) ? ciudad.split("-")[1] : 'm';
        //filtramos los bienes del mismo tipo
        var list = bienesEnVenta.filter( s => (s.tipoDeBien === tipoDeBien  &&  s.slug !== slug) );
        var listTemp = list.map( s=>{
            var score = 0;
            if(s.ciudad){
                var d = s.ciudad.split("-")[0];
                var m = s.ciudad.split("-")[1];
                score = ( m === municipio ) ? 2 : ( d === departamento ) ? 1 : 0;
            }
            return {
                score: score,
                ...s,
            }
        });
        list = listTemp.sort( (a,b)=> b.score - a.score );
        setListSales( list.slice(0, 3) );
    }


    return (
        <div className="o-section-more-sales">
            <div className="o-section-more-sales-container">
                <h2 className="o-section-more-sales-title custom-h h3">{ tituloMasBienesEnVenta }</h2>
                <p className="o-section-more-sales-text">{ textoDeApoyoMasBienesEnVenta }</p>
                <div className="o-section-more-sales-list-container">
                    
                    {
                        listSales &&
                        listSales.map( (s, i)=>( <CardSale sale={ s } key={ i }/> ) )
                    }
                </div>
            </div>
        </div>
    )
}

export default SectionMoreSales
